import './AssignmentPageModals.scss';

import React from 'react';
import update from 'immutability-helper';
import moment from 'moment';

import AssignmentEditForm from './AssignmentEditForm';
import Modal from 'components/Modal';

import { MODALS } from 'utils/constants';

export default class AssignmentEditModal extends React.Component {
    static propTypes = {
        cancelModal: React.PropTypes.func.isRequired,
        closeModal: React.PropTypes.func.isRequired,
        existingAssignmentState: React.PropTypes.string,
        isSaving: React.PropTypes.bool.isRequired,
        openModal: React.PropTypes.func.isRequired,
        saveAssignment: React.PropTypes.func.isRequired,
        setAssignment: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
        assignment: React.PropTypes.object.isRequired
    };

    _handleChange(event) {
        let name = event.target.getAttribute('name');
        let newAssignmentObj = update(this.props.assignment, {});
        newAssignmentObj[name] = event.target.value;

        this.props.setAssignment(newAssignmentObj);
    }

    _handleStateChange(newState) {
        let newAssignmentObj = update(this.props.assignment, {
            state: {$set: newState}
        });

        this.props.setAssignment(newAssignmentObj);
    }

    _handleDateChange(date, type) {
        //handle date change vs blur
        if(moment.isMoment(date)) {
            let newAssignmentObj = update(this.props.assignment, {});

            newAssignmentObj[type] = parseInt(date.format('x'), 10);

            this.props.setAssignment(newAssignmentObj);
        }
    }

    _handleSave(isValid) {
        if(isValid === true) {
            this.props.saveAssignment(() => {
                this.props.openModal(MODALS.ASSIGNMENT_DETAILS);
            });
        }
    }



    render() {
        let { assignment, cancelModal, closeModal, existingAssignmentState,isSaving, openModal, show } = this.props;

        return (
            <Modal show={show}
                   className="assignment-edit"
                   handleClose={closeModal.bind(this)}>
                <div className="assignment-edit__form-wrapper">
                    <AssignmentEditForm assignment={assignment}
                                        closeModal={cancelModal.bind(this)}
                                        existingAssignmentState={existingAssignmentState}
                                        handleChange={this._handleChange.bind(this)}
                                        handleDateChange={this._handleDateChange.bind(this)}
                                        handleStateChange={this._handleStateChange.bind(this)}
                                        isSaving={isSaving}
                                        onValid={this._handleSave.bind(this, true)}
                                        onInvalid={this._handleSave.bind(this, false)}
                                        openModal={openModal.bind(this)} />
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentEditModal.js